import { create } from 'zustand';

// Zustand 스토어 정의
interface PolicyState {
  termsContent: string | null;
  termsPolicyId: number | null;
  privacyContent: string | null;
  privacyPolicyId: number | null;
  setPolicy: (terms: string, termsPolicyId: number, privacy: string, privacyPolicyId: number) => void;
}

const usePolicyStore = create<PolicyState>((set) => ({
  termsContent: null, // 초기 상태는 null로 설정
  termsPolicyId: null,
  privacyContent: null, // 초기 상태는 null로 설정
  privacyPolicyId: null,

  // setPolicy 함수는 정책 데이터를 받아서 상태를 업데이트
  setPolicy: (terms: string, termsPolicyId: number, privacy: string, privacyPolicyId: number) =>
    set({
      termsContent: terms,
      termsPolicyId: termsPolicyId,
      privacyContent: privacy,
      privacyPolicyId: privacyPolicyId
    })
}));

export default usePolicyStore;
